import { render, staticRenderFns } from "./ReadResult.vue?vue&type=template&id=01008612"
import script from "./ReadResult.vue?vue&type=script&lang=js"
export * from "./ReadResult.vue?vue&type=script&lang=js"
import style0 from "./ReadResult.vue?vue&type=style&index=0&id=01008612&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports